export const TESTIMONIALS = [
  {
    quote: 'Pin feedback directly on any element. No more vague emails or annotated screenshots that miss the mark.',
    name: 'For Design Teams',
    role: 'Cut review cycles in half',
    company: '',
    initials: 'DT',
    gradient: 'from-blue-500 to-indigo-600',
  },
  {
    quote: 'Share a link with clients, they leave feedback right on the page. No signup, no friction, no back-and-forth.',
    name: 'For Agencies',
    role: 'Client reviews without the chaos',
    company: '',
    initials: 'AG',
    gradient: 'from-purple-500 to-pink-600',
  },
  {
    quote: 'Every pin auto-captures context — page URL, viewport, browser. Feedback becomes actionable tickets, not guesswork.',
    name: 'For Developers',
    role: 'Bug reports that actually help',
    company: '',
    initials: 'DV',
    gradient: 'from-emerald-500 to-teal-600',
  },
];
